// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1eyVr","requiredAsterisk":"Info_requiredAsterisk__3xHjA"};